export const trackingEvents = {
    Shoppable: {
        filter_type: 'shoppable banner',
        facetName: 'customPet',
    },
    VisualNav: {
        filter_type: 'visual nav',
        facetName: 'categories.name.default',
    },
    Multirow: {
        filter_type: '',
        facetName: '',
    },
    Promo: {
        filter_type: '',
        facetName: '',
    },
    Tips: {
        filter_type: '',
        facetName: '',
    },
};
